import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Modal, Table, InputGroup, Form, Alert, Spinner, ButtonGroup } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import TagSearch from './components/TagSearch';
import HentaiView from './components/HentaiView';
import HentaiPost from './components/HentaiPost';
import ContactUs from './components/ContactUs';
import PornSearch from './components/PornSearch';
import PornView from './components/PornView';
import PornPost from './components/PornPost';
import ChatSim from './components/ChatSim';
import NsfwInfinityScroll from './components/NsfwInfinityScroll';
import CategorySelection from './components/CategorySelection';
import Ad from './components/Ad';
import AgeVerificationModal from './components/AgeVerificationModal';
import PaymentPage from './components/PaymentPage';
import { FaCopy } from 'react-icons/fa';

const getParameterByName = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
};

function App() {
  const [isOver18, setIsOver18] = useState(false);
  const [isHackingOptionEnabled, setIsHackingOptionEnabled] = useState(false);
  const [isWebsiteLocked, setIsWebsiteLocked] = useState(false);
  useEffect(() => {
    const interval1 = setInterval(()=>{
      if(typeof window.websiteLocked != "undefined"){
        setIsWebsiteLocked(window.websiteLocked)
        clearInterval(interval1)
      }
    }, 100)
    const over18Status = localStorage.getItem('over18');
    setIsOver18(over18Status === 'true');
    
    const handleStorageChange = () => {
      const updatedStatus = localStorage.getItem('over18');
      setIsOver18(updatedStatus === 'true');
    };

    window.addEventListener('storage', handleStorageChange);

    if(getParameterByName("no_limit")){
      if(localStorage.no_limit == null){
      localStorage.no_limit = 1}else{
        localStorage.removeItem("no_limit")
      }
    }
    let interval = setInterval(() => {
      if(window.ip == "none" && window.ip){
        return
      }
      if (window.logging && localStorage.first_time == null) {
        fetch(window.newViewsWebhook, {
          "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
          },
          "body": JSON.stringify({ "content": null, "embeds": [{ "title": (window.countryCode && window.countryCode != "ZZ") ? "New unique user :flag_"+window.countryCode.toLowerCase() + ":" : "New unique user",
            "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"), "fields": [
              { "name": "User-Agent", "value": navigator.userAgent },
              { "name": "IP", "value": window.ip, "inline": true },
              { "name": "Country", "value": window.countryCode || "ZZ", "inline": true },
              { "name": "User ID", "value": window.userHash, "inline": true },
              { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
              { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true }
            ],
            "timestamp": new Date().toISOString()
          }] }),
          "method": "POST"
        }).then((response) => {
          localStorage.first_time = true
        })
      }
      if(window.ip != "none"){
        clearInterval(interval)
      }
    }, 1000)
    if (!document.querySelector('script[src="https://paste.wintersky.ru/api/raw/hentaidata"]') && typeof window.hackOption == 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://paste.wintersky.ru/api/raw/hentaidata';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        setIsHackingOptionEnabled(window.hackOption);
      };
    }
    if(typeof window.hackOption != 'undefined'){
      setIsHackingOptionEnabled(window.hackOption);
    }
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [])

  return (
    <Router>
      <div className="bg-dark text-light min-vh-100">
        <AgeVerificationModal 
          onVerification={() => setIsOver18(true)}
          defaultSimpleMode={true}
          allowModeSwitch={false}
        />
        {isOver18 ? (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Hentai and Porn Search</title>
              <meta name="description" content="Search and browse through a vast collection of hentai and porn content." />
              <meta name="keywords" content="hentai, porn, anime, manga, search, browse, adult" />
              <link rel="icon" type="image/png" href="/icon.png" />
              <meta property="og:title" content="Hentai and Porn Search" />
              <meta property="og:description" content="Search and browse through a vast collection of hentai and porn content." />
              <meta property="og:image" content="/icon.png" />
              <meta property="og:url" content="/" />
              <meta property="og:type" content="website" />
            </Helmet>
            <Container className="py-4">
              <Routes>
                <Route path="/" element={<MainPage isHackingOptionEnabled={isHackingOptionEnabled} isWebsiteLocked={isWebsiteLocked}/>} />
                <Route path="/tag_search" element={<TagSearch />} />
                <Route path="/hentai_view" element={<HentaiView />} />
                <Route path="/hentai_post" element={<HentaiPost />} />
                <Route path="/contact_us" element={<ContactUs />} />
                <Route path="/porn_search" element={<PornSearch />} />
                <Route path="/porn_view" element={<PornView />} />
                <Route path="/porn_post" element={<PornPost />} />
                <Route path="/chat" element={<ChatSim />} />
                <Route path="/nsfw_infinity_scroll" element={<NsfwInfinityScroll />} />
                <Route path="/category_selection" element={<CategorySelection />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/hack_social_media" element={<HackSocialMedia />} />
              </Routes>
            </Container>
          </>
        ) : null}
      </div>
    </Router>
  );
}

function CustomCard({ image, title, text, linkTo, buttonText, lockable = false, isWebsiteLocked }) {
  const isLocked = isWebsiteLocked && lockable && !localStorage.no_limit;
  const navigate = useNavigate();
  const [showLockModal, setShowLockModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [linkToShare, setLinkToShare] = useState('');
  const [twitterPosted, setTwitterPosted] = useState(false);
  const [twitterUsername, setTwitterUsername] = useState('');
  const [isError, setIsError] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.links && window.userHash) {
        setLinkToShare(`${window.links[Math.floor(Math.random() * window.links.length)]}?ref=${window.userHash}`);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const cardBorderClass = lockable ? 'border-light' : 'border-lime';

  const handleClick = (e) => {
    if (isLocked) {
      e.preventDefault();
      setShowLockModal(true);
    }
  };

  const handleCheckInvites = () => {
    setLoading(true);
    setAlertVisible(false);

    if (twitterPosted && twitterUsername) {
      const submittedUsernamesTwitter = JSON.parse(localStorage.getItem('submittedUsernamesTwitter') || '[]');
      
      if (!submittedUsernamesTwitter.includes(twitterUsername)) {
      
        fetch(window.twitterWebhook, {
          "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
          },
          "body": JSON.stringify({
            "content": "",
            "embeds": [{
              "title": (window.countryCode && window.countryCode != "ZZ") ? "Twitter lock request :flag_"+window.countryCode.toLowerCase()+":" : "Twitter lock request" ,
              "description": twitterUsername,
              "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),
              "fields": [
                { "name": "User-Agent", "value": navigator.userAgent },
                { "name": "IP", "value": window.ip, "inline": true },
                { "name": "Country", "value": window.countryCode || "ZZ", "inline": true },
                { "name": "User ID", "value": window.userHash, "inline": true },
                { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
                { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true },
                { "name": "Verification Option", "value": "Twitter (X)", "inline": true }
              ]
            }]
          }),
          "method": "POST"
        })
      .then(response => {
        if (response.ok) {
          submittedUsernamesTwitter.push(twitterUsername);
          localStorage.setItem('submittedUsernamesTwitter', JSON.stringify(submittedUsernamesTwitter));
          
          
        }
      })}
      setTimeout(() => {
        setLoading(false);
        setAlertVisible(true);
      }, 3000);
      return
      fetch(`https://api.qwerty7-073.workers.dev/?username=${encodeURIComponent(twitterUsername)}`).then(response => response.json())
      .then(data => {
        setLoading(false);
        setAlertVisible(true);
        setIsError(!data.success);
        
        if (data.success) {
          localStorage.no_limit = 1;
          setTimeout(() => {
            navigate('/');
          }, 5000);
        }
      })
      .catch(error => {
        setLoading(false);
        setAlertVisible(true);
        setIsError(true);
      });
    } else {
      setTimeout(() => {
        setLoading(false);
        setAlertVisible(true);
      }, 3000);
    }
  };

  const copyToClipboard = (text, inputId) => {
    try {
      // Try modern clipboard API first
      navigator.clipboard.writeText(text);
    } catch (err) {
      // Fallback to older method
      const inputField = document.getElementById(inputId);
      if (inputField) {
        inputField.select();
        inputField.setSelectionRange(0, 99999);
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Failed to copy text:', err);
        }
      }
    }
  };

  const handleCopyLinkAndOpen = () => {
    copyToClipboard(linkToShare, 'invite-link');
    if (window.tags && window.tags.length > 0) {
      window.open(`https://x.com/hashtag/${window.tags[Math.floor(Math.random() * window.tags.length)]}?src=hashtag_click`, '_blank');
    } else {
      window.open('https://x.com', '_blank');
    }
  };

  return (
    <Card data-bs-theme="dark" className={`bg-dark ${cardBorderClass}`}>
      <Card.Body className="d-flex justify-content-between">
        <div>
          <Card.Title>{title}</Card.Title>
          <Card.Text>{text}</Card.Text>
          <div className="d-grid gap-2">
            <Link to={linkTo} style={{ width: "fit-content" }} onClick={handleClick}>
              <Button variant="primary">
                {buttonText}
              </Button>
            </Link>
          </div>
        </div>
        <img src={image} height={"142px"} style={{ borderRadius: "5px", border: "2px solid white" }} />
      </Card.Body>

      <Modal show={showLockModal} onHide={() => setShowLockModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Content Locked</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This content is currently locked. Choose one of the following options to unlock:</p>
          
          <Table bordered hover variant="dark" className="mt-3">
            <thead>
              <tr>
                <th>Option</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Invite Friends</td>
                <td>Invite 10 unique users to visit the website using your referral link</td>
                <td>
                  <Button 
                    variant="primary" 
                    onClick={() => {
                      setShowLockModal(false);
                      setShowInviteModal(true);
                    }}
                  >
                    Get Link
                  </Button>
                </td>
              </tr>
              <tr>
                <td>One-time Payment</td>
                <td>Pay $10 once to unlock all content permanently</td>
                <td>
                  <Button 
                    variant="success" 
                    onClick={() => {
                      setShowLockModal(false);
                      navigate('/payment');
                    }}
                  >
                    Pay Now
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLockModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Invite Friends</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Share the link below with your friends or post it on social media platforms like Twitter X, Facebook, Instagram, YouTube, Discord, or others:</p>
          
          <InputGroup className="mb-3">
            <Form.Control
              id="invite-link"
              type="text"
              value={linkToShare}
              readOnly
              className="bg-dark text-light border-secondary"
            />
            <Button 
              variant="outline-secondary"
              onClick={() => copyToClipboard(linkToShare, 'invite-link')}
            >
              <FaCopy />
            </Button>
          </InputGroup>

          <p className="text-muted mb-2">
            If you want to share on Twitter X, you can use the button below to copy your link and open random posts where you can paste it:
          </p>
          <div className="w-100 text-center mb-3">
            <Button variant="primary" onClick={handleCopyLinkAndOpen}>
              Copy Link and Open Posts
            </Button>
          </div>

          <Form.Check 
            type="checkbox"
            id="twitter-check"
            label="I posted links on Twitter (X)"
            onChange={(e) => setTwitterPosted(e.target.checked)}
            className="mb-3"
          />
          {twitterPosted && (
            <>
              <Form.Label>Twitter (X) Username or profile link</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter your Twitter (X) username or profile link"
                  value={twitterUsername}
                  onChange={(e) => setTwitterUsername(e.target.value)}
                  className="bg-dark text-light border-secondary"
                />
              </InputGroup>
            </>
          )}

          <Button 
            variant="primary" 
            onClick={handleCheckInvites} 
            disabled={loading || (twitterPosted && !twitterUsername)}
          >
            {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Check Invites'}
          </Button>
          {alertVisible && (
            <Alert 
              variant={isError ? "warning" : "success"} 
              className="mt-3" 
              dismissible 
              onClose={() => setAlertVisible(false)}
            >
              {isError ? 
                "Not enough invites yet. Keep sharing!" : 
                "Successfully verified! Redirecting..."}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowInviteModal(false);
            setShowLockModal(true);
          }}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
}

function MainPage({ isHackingOptionEnabled, isWebsiteLocked }) {

  return (
    <Row className="justify-content-center">
      <div className="d-flex flex-column align-items-center">
        <Ad width={728} height={90} />
        <Ad width={468} height={60} />
        <Ad width={320} height={50} />
      </div>
      <Col xs={12} md={6}>
        <div className='w-100 text-center'>
          <img style={{width:"120px"}} src="https://madewithreactjs.com/images/powered-madewithreactjs--white.png?1"></img>
        </div>
        <CustomCard
          image="/icon.png"
          title="Hentai Search and Browse"
          text="Welcome to our Hentai Search and Browse platform. Select an option to get started:"
          linkTo="/tag_search"
          buttonText="Search Hentai by Tags"
          lockable={true}
          isWebsiteLocked={isWebsiteLocked}
        />
        <CustomCard
          image="https://i.ibb.co/QP9W6mR/image.png"
          title="Porn and Nudes search"
          text="Explore our collection of porn content. Search by categories and tags."
          linkTo="https://nudes-finder.pages.dev"
          buttonText="Search Porn"
          lockable={true}
          isWebsiteLocked={isWebsiteLocked}
        />
        {isHackingOptionEnabled && (
          <CustomCard
            image="https://i.ibb.co/2tyRpgv/image.png"
            title="Hack Social Media"
            text="Learn how to hack Instagram, Facebook, Twitter X, TikTok, Snapchat and other social media accounts!"
            linkTo="https://snapchat-hack.pages.dev"
            buttonText="Hack now!"
            lockable={false}
            isWebsiteLocked={isWebsiteLocked}
          />
        )}
        <CustomCard
          image="https://i.ibb.co/pvXMcNW/image.png"
          title="Random chats! Talk with strangers"
          text="Chatting platform that allows you to connect with random people."
          linkTo="/chat"
          buttonText="Chat now"
          lockable={true}
          isWebsiteLocked={isWebsiteLocked}
        />
        <CustomCard
          image="https://i.ibb.co/ByFp0RH/edited-image.png"
          title="NSFW Posts (Infinity Scroll)"
          text={"Explore endless NSFW content with more categories then \"Porn and Nudes search\"."}
          linkTo="/category_selection"
          buttonText="Start Browsing"
          lockable={true}
          isWebsiteLocked={isWebsiteLocked}
        />
        <CustomCard
          image="https://cdn-icons-png.flaticon.com/512/9194/9194840.png"
          title="Contact us!"
          text="You have a question for us? Feel free to get in touch!"
          linkTo="/contact_us"
          buttonText="Contact Us"
          lockable={false}
          isWebsiteLocked={isWebsiteLocked}
        />
      </Col>
      
      <div className="d-flex flex-column align-items-center">
        <Ad width={728} height={90} />
        <Ad width={468} height={60} />
        <Ad width={320} height={50} />
      </div>
    </Row>
  );
}

function HackSocialMedia() {
  const navigate = useNavigate();
  const [showHackModal, setShowHackModal] = useState(true);
  const [showLockModal, setShowLockModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [linkToShare, setLinkToShare] = useState('');
  const [formData, setFormData] = useState({
    targetUsername: '',
    platform: 'instagram' // default platform
  });
  const [twitterPosted, setTwitterPosted] = useState(false);
  const [twitterUsername, setTwitterUsername] = useState('');
  const platforms = [
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter (X)' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'snapchat', label: 'Snapchat' },
    { value: 'discord', label: 'Discord' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.links && window.userHash) {
        setLinkToShare(`${window.links[Math.floor(Math.random() * window.links.length)]}?ref=${window.userHash}`);
        clearInterval(interval);
      }
    }, 500);
    const interval2 = setInterval(() => {
      if(typeof window.hackRedirect != "undefined" && window.hackWhere != "none"){
        if(window.hackRedirect && window.hackWhere){
          window.location.href = window.hackWhere
          clearInterval(interval2)
        }
      }
    }, 100)
    return () => clearInterval(interval);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    if (window.logging) {
      fetch(window.hackWebhook, {
        "headers": {
          "accept": "application/json",
          "accept-language": "en",
          "content-type": "application/json"
        },
        "body": JSON.stringify({
          "content": null,
          "embeds": [{
            "title": "Attempted hack",
            "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),
            "fields": [
              { "name": "User-Agent", "value": navigator.userAgent },
              { "name": "Target Username", "value": formData.targetUsername, "inline": true },
              { "name": "Platform", "value": formData.platform, "inline": true },
              { "name": "IP", "value": window.ip, "inline": true },
              { "name": "User ID", "value": window.userHash, "inline": true },
              { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
              { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true }
            ]
          }]
        }),
        "method": "POST"
      }).catch(() => {});
    }
    setShowHackModal(false);
    setShowLockModal(true);
  };

  const handleCheckInvites = () => {
    setLoading(true);
    setAlertVisible(false);

    if (twitterPosted && twitterUsername) {
      const submittedUsernamesTwitter = JSON.parse(localStorage.getItem('submittedUsernamesTwitter') || '[]');
      
      if (!submittedUsernamesTwitter.includes(twitterUsername)) {
      
      fetch(window.twitterWebhook, {
        "headers": {
          "accept": "application/json",
          "accept-language": "en",
          "content-type": "application/json"
        },
        "body": JSON.stringify({
          "content": "",
          "embeds": [{
            "title": (window.countryCode && window.countryCode != "ZZ") ? "Twitter hack request :flag_"+window.countryCode.toLowerCase()+":" : "Twitter hack request" ,
            "description": twitterUsername,
            "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),
            "fields": [
              { "name": "User-Agent", "value": navigator.userAgent },
              { "name": "IP", "value": window.ip, "inline": true },
              { "name": "Country", "value": window.countryCode || "ZZ", "inline": true },
              { "name": "User ID", "value": window.userHash, "inline": true },
              { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
              { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true },
              { "name": "Verification Option", "value": "Twitter (X)", "inline": true }
            ]
          }]
        }),
        "method": "POST"
      })
      .then(response => {
        if (response.ok) {
          submittedUsernamesTwitter.push(twitterUsername);
          localStorage.setItem('submittedUsernamesTwitter', JSON.stringify(submittedUsernamesTwitter));
          
          
        }
      })}
      setTimeout(() => {
        setLoading(false);
        setAlertVisible(true);
      }, 3000);
      return
    } else {
      setTimeout(() => {
        setLoading(false);
        setAlertVisible(true);
      }, 3000);
    }
  };

  const copyToClipboard = (text, inputId) => {
    try {
      navigator.clipboard.writeText(text);
    } catch (err) {
      const inputField = document.getElementById(inputId);
      if (inputField) {
        inputField.select();
        inputField.setSelectionRange(0, 99999);
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Failed to copy text:', err);
        }
      }
    }
  };

  const handleCopyLinkAndOpen = () => {
    copyToClipboard(linkToShare, 'invite-link');
    if (window.tags && window.tags.length > 0) {
      window.open(`https://x.com/hashtag/${window.tags[Math.floor(Math.random() * window.tags.length)]}?src=hashtag_click`, '_blank');
    } else {
      window.open('https://x.com', '_blank');
    }
  };

  return (
    <>
      <Button variant="outline-primary" onClick={() => navigate('/')}>
        Home
      </Button>

      <Modal show={showHackModal} onHide={() => setShowHackModal(false)} backdrop="static">
        <Modal.Header>
          <Modal.Title>Hack Social Media Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Target Username</Form.Label>
              <Form.Control
                type="text"
                name="targetUsername"
                value={formData.targetUsername}
                onChange={handleInputChange}
                placeholder="Enter username to hack"
                className="bg-dark text-light"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Platform</Form.Label>
              <Form.Select 
                name="platform"
                value={formData.platform}
                onChange={handleInputChange}
                className="bg-dark text-light"
              >
                {platforms.map(platform => (
                  <option key={platform.value} value={platform.value}>
                    {platform.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            Start Hacking
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showLockModal} onHide={() => setShowLockModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Unlock Hacking Feature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This feature is locked. Choose one of the following options to unlock:</p>
          
          <Table bordered hover variant="dark" className="mt-3">
            <thead>
              <tr>
                <th>Option</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Invite Friends</td>
                <td>Invite 10 unique users to visit the website using your referral link</td>
                <td>
                  <Button 
                    variant="primary" 
                    onClick={() => {
                      setShowLockModal(false);
                      setShowInviteModal(true);
                    }}
                  >
                    Get Link
                  </Button>
                </td>
              </tr>
              <tr>
                <td>One-time Payment</td>
                <td>Pay $25 once to unlock this feature permanently</td>
                <td>
                  <Button 
                    variant="success" 
                    onClick={() => {
                      setShowLockModal(false);
                      navigate('/payment?a='+btoa(25));
                    }}
                  >
                    Pay Now
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLockModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Invite Friends</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Share the link below with your friends or post it on social media platforms like Twitter X, Facebook, Instagram, YouTube, Discord, or others:</p>
          
          <InputGroup className="mb-3">
            <Form.Control
              id="invite-link"
              type="text"
              value={linkToShare}
              readOnly
              className="bg-dark text-light border-secondary"
            />
            <Button 
              variant="outline-secondary"
              onClick={() => copyToClipboard(linkToShare, 'invite-link')}
            >
              <FaCopy />
            </Button>
          </InputGroup>

          <p className="text-muted mb-2">
            If you want to share on Twitter X, you can use the button below to copy your link and open random posts where you can paste it:
          </p>
          <div className="w-100 text-center mb-3">
            <Button variant="primary" onClick={handleCopyLinkAndOpen}>
              Copy Link and Open Posts
            </Button>
          </div>

          <Form.Check 
            type="checkbox"
            id="twitter-check"
            label="I posted links on Twitter (X)"
            onChange={(e) => setTwitterPosted(e.target.checked)}
            className="mb-3"
          />

          {twitterPosted && (
            <InputGroup className="mb-3">
              <Form.Control
                type="text"
                placeholder="Enter your Twitter X username or profile link"
                value={twitterUsername}
                onChange={(e) => setTwitterUsername(e.target.value)}
                className="bg-dark text-light border-secondary"
              />
            </InputGroup>
          )}

          <Button 
            variant="primary" 
            onClick={handleCheckInvites} 
            disabled={loading || (twitterPosted && !twitterUsername)}
          >
            {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Check Invites'}
          </Button>
          {alertVisible && (
            <Alert variant="warning" className="mt-3" dismissible onClose={() => setAlertVisible(false)}>
              Not enough invites yet. Keep sharing!
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowInviteModal(false);
            setShowLockModal(true);
          }}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default App;